import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/joy';

import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

const CpuBar = ({ label, value }: { label: string; value: number }) => {
  const width = Math.min(value * 10, 100);
  return (
    <div className="mb-4">
      <div className="flex justify-between mb-1">
        <span className="text-sm text-gray-600">{label}</span>
        <span className="text-sm text-gray-600">{value.toFixed(2)}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-blue-500 h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
};

export default function CpuLoadCard({ heartbeat}: Props) {
  const { t } = useTranslation();
  const cpu = heartbeat.cpu_load;

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.cpu.title')}
        </Typography>

        {cpu ? (
          <div className="mt-3">
            <CpuBar label={t('heartbeat.cpu.one_minute')} value={cpu['1.0'] ?? 0} />
            <CpuBar label={t('heartbeat.cpu.five_minutes')} value={cpu['5.0'] ?? 0} />
            <CpuBar label={t('heartbeat.cpu.fifteen_minutes')} value={cpu['15.0'] ?? 0} />
          </div>
        ) : (
          <p className="text-sm text-center text-gray-500">
            {t('heartbeat.cpu.no_info')}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
